import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary/10 text-primary",
        secondary: "border-border/60 bg-secondary text-secondary-foreground",
        success: "border-emerald-500/30 bg-emerald-500/10 text-emerald-300",
        info: "border-sky-500/30 bg-sky-500/10 text-sky-300",
        warn: "border-amber-500/30 bg-amber-500/10 text-amber-300",
        error: "border-rose-500/30 bg-rose-500/10 text-rose-300",
        neutral: "border-slate-500/30 bg-slate-500/10 text-slate-300",
        outline: "border-border/60 text-foreground/80",
      },
    },
    defaultVariants: { variant: "secondary" },
  }
);

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { badgeVariants };
